module.exports = __webpack_public_path__ + "static/img/Frame2366@2x.7758a27.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Frame2366@2x.png
// module id = ap6E
// module chunks = 1